import React from 'react';
import {observer} from 'mobx-react';
import ApproveButton from '../ApproveButton';

const ApproveButtonCell = observer(({model, uiState}) => {
  return <ApproveButton model={model} uiState={uiState}/>;
});

export default ApproveButtonCell;
